import React from "react";
import SwitcherBusStop from "./components/SwitcherBusStop";
import SwitcherRoadMap from "./components/SwitcherRoadMap";
import LoaderCircle from "../loaders/LoaderCircle";
import styled from "styled-components";

const SwitchersMapMod = ({ isFetchRoadmap }) => {
    return (
        <div className="map-screen__switchers-panel">
            {isFetchRoadmap ?
                <Container>
                    <LoaderCircle />
                    {/* <Text>{isFetchRoadmap ? 'Загрузка транспорта' : ''}</Text> */}
                </Container> :
                <>
                    <SwitcherBusStop />
                    <SwitcherRoadMap />
                </>}
        </div>
    )
}

export default SwitchersMapMod;

const Container = styled.div`
display: flex;
width:100%;
height:30px;
flex-direction: row;
align-items: center;
justify-content: center;
gap: 10px;
`
const Text = styled.span`
font-size: 16px;
font-weight: 500;
font-color: gray;
`